const cards = [
  {
    id: 1,
    title: '斗破苍穹',
    author: '天蚕土豆',
    category: '玄幻修仙',
    status: '连载中',
    chapters: '第428话',
    views: '12.8亿',
    rating: '9.5',
    tags: ['国漫', '热门'],
    cover: 'https://readdy.ai/api/search-image?query=Stylized%20manga%20cover%20art%20featuring%20a%20powerful%20young%20warrior%20with%20flaming%20energy%20aura%2C%20fantasy%20Chinese%20cultivation%20theme%2C%20warm%20orange%20and%20gold%20toned%20illustration%2C%20clean%20simple%20background%20with%20soft%20cream%20gradient%2C%20dynamic%20pose%2C%20anime%20art%20style%2C%20high%20detail%20character%20design%2C%20editorial%20quality&width=800&height=1060&seq=manga-card-01&orientation=portrait',
  },
  {
    id: 2,
    title: '一人之下',
    author: '米二',
    category: '都市异能',
    status: '连载中',
    chapters: '第526话',
    views: '8.6亿',
    rating: '9.7',
    tags: ['国漫', '精品'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20modern%20urban%20fantasy%20manga%20cover%2C%20a%20mysterious%20young%20man%20with%20supernatural%20energy%20surrounded%20by%20floating%20talismans%2C%20dark%20warm%20coral%20accents%2C%20minimal%20cream%20background%2C%20anime%20art%20style%2C%20dynamic%20composition%2C%20high%20quality%20illustration&width=800&height=1060&seq=manga-card-02&orientation=portrait',
  },
  {
    id: 3,
    title: '海贼王',
    author: '尾田荣一郎',
    category: '热血冒险',
    status: '连载中',
    chapters: '第1120话',
    views: '35.2亿',
    rating: '9.8',
    tags: ['日漫', '经典'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20pirate%20adventure%20manga%20cover%20style%2C%20young%20hero%20with%20straw%20hat%20and%20dynamic%20action%20pose%2C%20warm%20golden%20sunset%20tones%2C%20clean%20cream%20background%2C%20anime%20art%20style%2C%20energetic%20composition%2C%20high%20detail&width=800&height=1060&seq=manga-card-03&orientation=portrait',
  },
  {
    id: 4,
    title: '女神降临',
    author: '猫咪',
    category: '恋爱校园',
    status: '已完结',
    chapters: '共228话',
    views: '6.3亿',
    rating: '9.3',
    tags: ['韩漫', '人气'],
    cover: 'https://readdy.ai/api/search-image?query=Korean%20romance%20webtoon%20style%20cover%2C%20beautiful%20female%20character%20with%20elegant%20makeup%20and%20fashion%2C%20soft%20warm%20pink%20and%20coral%20tones%2C%20clean%20cream%20background%2C%20modern%20manhwa%20art%20style%2C%20romantic%20atmosphere%2C%20high%20detail&width=800&height=1060&seq=manga-card-04&orientation=portrait',
  },
  {
    id: 5,
    title: '狐妖小红娘',
    author: '小新',
    category: '古风仙侠',
    status: '连载中',
    chapters: '第486话',
    views: '9.1亿',
    rating: '9.6',
    tags: ['国漫', '推荐'],
    cover: 'https://readdy.ai/api/search-image?query=Chinese%20fantasy%20romance%20manga%20cover%2C%20beautiful%20fox%20spirit%20girl%20with%20flowing%20traditional%20hanfu%20dress%2C%20ancient%20Chinese%20aesthetic%2C%20warm%20peach%20and%20coral%20tones%2C%20soft%20cream%20background%2C%20anime%20art%20style%2C%20romantic%20atmosphere%2C%20high%20detail&width=800&height=1060&seq=manga-card-05&orientation=portrait',
  },
  {
    id: 6,
    title: '咒术回战',
    author: '芥见下下',
    category: '奇幻战斗',
    status: '连载中',
    chapters: '第263话',
    views: '15.7亿',
    rating: '9.4',
    tags: ['日漫', '火爆'],
    cover: 'https://readdy.ai/api/search-image?query=Japanese%20dark%20fantasy%20manga%20cover%2C%20powerful%20sorcerer%20character%20with%20mystical%20energy%20and%20dynamic%20battle%20pose%2C%20warm%20dark%20coral%20and%20amber%20accents%2C%20clean%20cream%20background%2C%20anime%20art%20style%2C%20intense%20atmosphere%2C%20high%20detail&width=800&height=1060&seq=manga-card-06&orientation=portrait',
  },
];

export default function CardsSection() {
  return (
    <section id="cards" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col sm:flex-row sm:items-end justify-between gap-4 mb-10">
          <div>
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950 mb-2">
              精选推荐漫画
            </h2>
            <p className="text-sm md:text-base text-foreground-500">
              编辑精选，热门好漫一网打尽
            </p>
          </div>
          <a
            href="#ranking"
            className="inline-flex items-center gap-1 text-sm font-medium text-primary-600 hover:text-primary-700 whitespace-nowrap cursor-pointer transition-colors"
          >
            查看排行 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-6 gap-4 md:gap-5">
          {cards.map((card) => (
            <div
              key={card.id}
              className="group cursor-pointer"
            >
              {/* Cover */}
              <div className="relative aspect-[3/4] rounded-xl overflow-hidden bg-background-100 mb-3">
                <img
                  src={card.cover}
                  alt={`${card.title} - ${card.category}漫画封面`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute top-2 left-2">
                  <span className={`px-1.5 py-0.5 rounded text-xs font-medium whitespace-nowrap ${
                    card.status === '连载中'
                      ? 'bg-primary-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {card.status}
                  </span>
                </div>
                <div className="absolute top-2 right-2">
                  <span className="px-1.5 py-0.5 rounded text-xs font-semibold bg-background-50/90 text-primary-600 whitespace-nowrap">
                    {card.rating}
                  </span>
                </div>
              </div>
              {/* Info */}
              <h3 className="font-semibold text-sm text-foreground-900 mb-1 truncate">
                {card.title}
              </h3>
              <p className="text-xs text-foreground-500 mb-1.5 truncate">
                {card.author} · {card.category}
              </p>
              <div className="flex items-center justify-between">
                <span className="text-xs text-foreground-400 truncate max-w-[60%]">{card.chapters}</span>
                <span className="text-xs text-foreground-300 whitespace-nowrap">{card.views}</span>
              </div>
              <div className="flex flex-wrap gap-1 mt-2">
                {card.tags.map((tag) => (
                  <span key={tag} className="px-1.5 py-0.5 text-xs bg-primary-50 text-primary-600 rounded whitespace-nowrap">
                    {tag}
                  </span>
                ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}